import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBullseye } from '@fortawesome/free-solid-svg-icons/faBullseye';
import type { IconProps } from '../../types';

export function BullseyeIcon({ 
  className, 
  size = 24, 
  color,
  'aria-label': ariaLabel = 'Bullseye',
}: IconProps) {
  return (
    <FontAwesomeIcon 
      icon={faBullseye}
      className={className}
      style={{ 
        width: typeof size === 'number' ? size : undefined,
        height: typeof size === 'number' ? size : undefined,
      }}
      color={color}
      aria-label={ariaLabel}
      role="img"
    />
  );
}
